'use strict';

var React = require('react');

var SvgShieldPersonIcon = function SvgShieldPersonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.907 2.915a1.75 1.75 0 0 1 2.186 0l.354.283a15.27 15.27 0 0 0 3.136 1.938l.9.416a1.709 1.709 0 0 1 1.002 1.622 13.42 13.42 0 0 1-.23 1.969.75.75 0 0 1-1.472-.284c.105-.544.176-1.127.204-1.752a.213.213 0 0 0-.132-.194l-.9-.415a16.75 16.75 0 0 1-3.445-2.129l-.354-.283a.25.25 0 0 0-.312 0l-.317.254a16.75 16.75 0 0 1-3.534 2.17l-.846.384c-.096.043-.136.127-.133.195.148 3.303 1.49 5.482 2.78 6.839a9.71 9.71 0 0 0 1.76 1.464 7.378 7.378 0 0 0 .741.42l.005.001a.75.75 0 0 1-.599 1.375l.299-.687-.299.687h-.002l-.002-.001-.006-.003-.017-.008a5.893 5.893 0 0 1-.256-.127 8.9 8.9 0 0 1-.676-.396 11.209 11.209 0 0 1-2.035-1.692c-1.499-1.576-3.025-4.086-3.192-7.805a1.71 1.71 0 0 1 1.011-1.628l.847-.384a15.25 15.25 0 0 0 3.217-1.976l.317-.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.018 14.75h-.036a2.768 2.768 0 0 0-2.454 1.488.692.692 0 0 0 .614 1.012h3.716c.52 0 .854-.551.614-1.012a2.768 2.768 0 0 0-2.455-1.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }));
};
SvgShieldPersonIcon.displayName = "ShieldPersonIcon";

exports.SvgShieldPersonIcon = SvgShieldPersonIcon;
